/**
 *
 * Asynchronously loads the component for NotificationList
 *
 */

import loadable from '../../utils/loadable';

export default loadable(() => import('./index'));
